define.alias("shared/errors/invalid-credentials-error", "calendar/errors/invalid-credentials-error");